import { useState } from "react";
import i18n from "i18next";
import { Menu, MenuItem, Button } from "@mui/material";

const languages = [
  { code: "en", label: "EN" },
  { code: "fr", label: "FR" },
  { code: "de", label: "DE" },
  { code: "es", label: "ES" },
  { code: "ru", label: "RU" },
  { code: "pt", label: "PT" },
  { code: "zh", label: "中文" },
];

export default function LanguageSwitcher({ isLight }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const currentLang = i18n.language || "en";

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleChangeLanguage = (code) => {
    i18n.changeLanguage(code);
    handleClose();
  };

  const currentLabel =
    languages.find((lang) => lang.code === currentLang)?.label || "EN";

  return (
    <>
      <Button
        onClick={handleClick}
        variant="outlined"
        size="small"
        sx={{
          minWidth: 40,
          fontWeight: "bold",
          color: !isLight ? "black" : "#fff",
          borderColor: !isLight ? "black" : "#fff",
        }}
      >
        {currentLabel}
      </Button>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={() => handleChangeLanguage(lang.code)}
          >
            {lang.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
